import { defineStore } from "pinia"

interface UserPayloadInterface {
  username: string
  password: string
}

export const useAuthStore = defineStore({
  id: "auth",
  state: () => ({
    authenticated: false,
    loading: false,
    session: "",
    uid: 0,
    password: "",
  }),
  persist: true,
  actions: {
    async authenticateUser({ username, password }: UserPayloadInterface) {
      // useFetch from nuxt 3

const config = useRuntimeConfig()
      const data = await $fetch("/odoo/jsonrpc", {
        method: "post",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: {
          jsonrpc: "2.0",
          method: "call",
          params: {
            service: "common",
            method: "authenticate",
            args: [config.public.dbname, username, password, {}],
          },
          id: 1,
        },
      })
      this.loading = false

      if (data?.result) {

        this.uid = data.result
        this.password = password
        console.log("auth.ts")
        this.authenticated = true // set authenticated  state value to true
      } else {
        this.authenticated = false
      }
    },
    logUserOut() {
      const token = useCookie("token") // useCookie new hook in nuxt 3
      this.authenticated = false // set authenticated  state value to false
      this.uid = 0
      this.password = ""
      token.value = null // clear the token cookie
    },
  },
  getters: {
    getSession: (state) => state.session,
    getUid: (state) => state.uid,
    getPassword: (state) => state.password,
  },
})
